import React from "react";
import Chart from "react-apexcharts";

const BreakHistoryChart = ({ chartData = [] }) => {
    // Format data from API
    const formatChartData = () => {
        if (!chartData || chartData.length === 0) {
            return {
                categories: [],
                activityCounts: [],
                lineData: []
            };
        }

        // Sort data by date (oldest to newest)
        const sortedData = [...chartData].sort((a, b) => new Date(a.date) - new Date(b.date));

        const categories = sortedData.map(item => {
            const date = new Date(item.date);
            return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        });

        const activityCounts = sortedData.map(item => item.activityCount);
        
        // For line data, we can use the same activity counts or create a trend line
        const lineData = activityCounts.map((count, index) => {
            if (index === 0) return count;
            // Simple moving average for trend line
            const prevCounts = activityCounts.slice(0, index + 1);
            return prevCounts.reduce((sum, val) => sum + val, 0) / prevCounts.length;
        });

        return { categories, activityCounts, lineData };
    };

    const { categories, activityCounts, lineData } = formatChartData();
    
    // Debug logging
    console.log('Chart Data:', chartData);
    console.log('Formatted Data:', { categories, activityCounts, lineData });

    const series = [
        {
            name: "Activity Count",
            type: "column",
            data: activityCounts,
        },
        {
            name: "Trend",
            type: "line",
            data: lineData,
        },
    ];

    const options = {
        chart: {
            height: 350,
            type: "line",
            stacked: false,
            toolbar: { show: false },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            width: [0, 2],
            curve: "smooth",
        },
        colors: ["#4CAF50", "#1B5E20"],
        xaxis: {
            categories: categories,
        },
        yaxis: {
            min: 0,
            forceNiceScale: true,
            decimalsInFloat: 0,
            title: {
                text: "Activity Count",
            },
        },
        fill: {
            opacity: [1, 0.2],
            type: ["gradient", "solid"],
            gradient: {
                shade: "light",
                type: "vertical",
                shadeIntensity: 0.1,
                opacityFrom: 0.8,
                opacityTo: 1,
            },
        },
        legend: {
            show: true,
        },
    };

    return (
        <div>
            <h3>Daily Activity submission count</h3>
            <Chart options={options} series={series} type="line" height={270} />
        </div>
    );
};

export default BreakHistoryChart;
